<template>
  <div class="footer">
    <div class="container">
      <div>Intertextile Shanghai Home Textiles</div>
      <div class="font">Powered by SoSee</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
    
  },
  methods: {
    
  }
};
</script>

<style lang="scss">
.footer{width: 100%;height: 70px;background: #000;color: #fff;font-size: 18px;text-align: center;line-height:25px;padding-top: 10px;box-sizing: border-box;}
.footer .font{font-size: 12px;}
</style>